import React from 'react';
import T from 'prop-types';
import cx from 'classnames';
import { AI_COHORTS_TOOLTIPS } from '../../../utils/advanced-metrics';
import Tooltip from '../../../components/Tooltip';
import { aiCohortsMap } from '../configs/constants';

const CustomChartLegend = ({
  series,
  activeItem,
  className,
  showTooltip = false,
  onClick,
  onMouseOver,
  onMouseOut,
}) => (
  <div className={cx('custom-chart-legend', className)}>
    {series.map(({ id, name, color }) => (
      <Tooltip
        key={id}
        disabled={!showTooltip}
        content={
          <div key={id}>
            <h6 className="h6 text-bold">{aiCohortsMap[id]}</h6>
            <p>{AI_COHORTS_TOOLTIPS[id]}</p>
          </div>
        }
        placement="top"
        colorVariant="light"
        overlayClassName="ai-segment-tooltip"
      >
        <div
          className={cx('custom-chart-legend__item', {
            'custom-chart-legend__item--active': activeItem && id === activeItem,
            'custom-chart-legend__item--inactive': activeItem && id !== activeItem,
          })}
          role="button"
          tabIndex={0}
          onClick={() => onClick({ id })}
          onMouseOver={() => onMouseOver({ id })}
          onFocus={() => onMouseOver({ id })}
          onMouseOut={() => onMouseOut({ id })}
          onBlur={() => onMouseOut({ id })}
        >
          <span className="custom-chart-legend__item--marker" style={{ backgroundColor: color }} />
          <span className="custom-chart-legend__item--name">{name.replace('End-', '')}</span>
        </div>
      </Tooltip>
    ))}
  </div>
);

CustomChartLegend.propTypes = {
  series: T.arrayOf(
    T.shape({
      id: T.string,
      name: T.string,
      color: T.string,
    })
  ).isRequired,
  className: T.string,
  activeItem: T.string,
  showTooltip: T.bool,
  onClick: T.func.isRequired,
  onMouseOver: T.func.isRequired,
  onMouseOut: T.func.isRequired,
};

export default CustomChartLegend;
